module.exports = __webpack_public_path__ + "static/fonts/Robotothin.72de91d.woff2";